<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลหน่วยงาน' : 'เพิ่มข้อมูลหน่วยงาน' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <legend class="fs-6 mb-2">ข้อมูลรหัสผู้ประกอบการ</legend>
    <hr class="border-0">
    <fieldset class="mb-4" style="margin-left: 10px;">
      <div class="row mb-3">
        <div class="col-sm-4"><label for="departmentCode" class="form-label mb-0 required">รหัสหน่วยงาน</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="departmentCode" formControlName="departmentCode"
                 maxlength="255">
          @if (submitted && form.get('departmentCode')?.errors?.['required']) {
            <div class="text-danger small">กรุณากรอกรหัสหน่วยงาน</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="nameTh" class="form-label mb-0 required">ชื่อ (ไทย)</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="nameTh" formControlName="nameTh" maxlength="255">
          @if (submitted && form.get('nameTh')?.errors?.['required']) {
            <div class="text-danger small">กรุณากรอกชื่อหน่วยงาน</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="taxid" class="form-label mb-0 required">เลขประจำตัวผู้เสียภาษี</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="taxid" formControlName="taxid" maxlength="13"
                 (keyup)="onTaxidKeyup()">
          @if (submitted && form.get('taxid')?.errors?.['required']) {
            <div class="text-danger small">กรุณากรอกเลขประจำตัวผู้เสียภาษี</div>
          }
        </div>
      </div>
    </fieldset>

    <legend class="fs-6 mb-2">ข้อมูลที่อยู่</legend>
    <hr class="border-0">
    <fieldset style="margin-left: 10px;">
      <div class="row mb-3">
        <div class="col-sm-4"><label for="address" class="form-label mb-0">ที่อยู่</label></div>
        <div class="col-sm-8">
          <textarea class="form-control form-control-sm" id="address" formControlName="address" rows="3"></textarea>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="province" class="form-label mb-0 required">จังหวัด</label></div>
        <div class="col-sm-8">
          <select class="form-select form-select-sm" id="province" formControlName="province"
                  [compareWith]="compareByNumericValue">
            <option [ngValue]="null">-เลือกจังหวัด-</option>
            @for (p of provinces; track p.id) {
              <option [ngValue]="p.id">{{ p.title }}</option>
            }
          </select>
          @if (isProvinceLoading) {
            <div class="form-text">กำลังโหลดข้อมูลจังหวัด...</div>
          }
          @if (submitted && form.get('province')?.errors?.['required']) {
            <div class="text-danger small">กรุณาเลือกจังหวัด</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="district" class="form-label mb-0 required">เขต/อำเภอ</label></div>
        <div class="col-sm-8">
          <select class="form-select form-select-sm" id="district" formControlName="district"
                  [compareWith]="compareByNumericValue">
            <option [ngValue]="null">-เลือกเขต/อำเภอ-</option>
            @for (d of districts; track d.id) {
              <option [ngValue]="d.id">{{ d.title }}</option>
            }
          </select>
          @if (isDistrictLoading) {
            <div class="form-text">กำลังโหลดข้อมูลเขต/อำเภอ...</div>
          }
          @if (submitted && form.get('district')?.errors?.['required']) {
            <div class="text-danger small">กรุณาเลือกเขต/อำเภอ</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="subdistrict" class="form-label mb-0 required">แขวง/ตำบล</label></div>
        <div class="col-sm-8">
          <select class="form-select form-select-sm" id="subdistrict" formControlName="subdistrict"
                  [compareWith]="compareByNumericValue">
            <option [ngValue]="null">-เลือกแขวง/ตำบล-</option>
            @for (sd of subdistricts; track sd.id) {
              <option [ngValue]="sd.id">{{ sd.title }}</option>
            }
          </select>
          @if (isSubdistrictLoading) {
            <div class="form-text">กำลังโหลดข้อมูลแขวง/ตำบล...</div>
          }
          @if (submitted && form.get('subdistrict')?.errors?.['required']) {
            <div class="text-danger small">กรุณาเลือกแขวง/ตำบล</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="zipcode" class="form-label mb-0 required">รหัสไปรษณีย์</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="zipcode" formControlName="zipcode" maxlength="5">
          @if (submitted && form.get('zipcode')?.errors?.['required']) {
            <div class="text-danger small">กรุณากรอกรหัสไปรษณีย์</div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="telephone" class="form-label mb-0">โทรศัพท์</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="telephone" formControlName="telephone"
                 maxlength="255">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="fax" class="form-label mb-0">โทรสาร</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="fax" formControlName="fax" maxlength="255">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="lat" class="form-label mb-0">Latitude</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="lat" formControlName="lat">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="lng" class="form-label mb-0">Longitude</label></div>
        <div class="col-sm-8">
          <input type="text" class="form-control form-control-sm" id="lng" formControlName="lng">
        </div>
      </div>
    </fieldset>

    <fieldset style="margin-left: 10px;">
      <div class="row mb-3">
        <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
        <div class="col-sm-8">
          <select class="form-select form-select-sm" id="state" formControlName="state">
            <option [ngValue]="1">เผยแพร่</option>
            <option [ngValue]="0">ไม่เผยแพร่</option>
          </select>
        </div>
      </div>

      @if (isEditMode) {
        <div class="row mb-3">
          <div class="col-sm-4"><label class="form-label mb-0">ผู้บันทึก</label></div>
          <div class="col-sm-8"><input class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-4"><label class="form-label mb-0">วันที่บันทึก</label></div>
          <div class="col-sm-8"><input class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
        </div>
      }
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก
    </button>
  }
</div>
